import React from 'react'
import PropTypes from 'prop-types'
import SvgCheckmark from 'hec/assets/icons/checkmark'
import {Heading} from '@/components/ui/heading'
import {Button} from '@/components/ui/button'
import {useIntl} from 'react-intl'
import {CURRENCY_SYMBOL} from 'hec/utils/constants'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const AddToCartContent = ({closeModal, cartData, productData}) => {
    const config = getConfig()
    const {
        app: {threeLetter}
    } = config
    const intl = useIntl()
    const {totalItems, productSubTotal} = cartData
    const {image, name, basePrice, quantity, currency} = productData
    const displayPrice =
        typeof basePrice === 'number' ? `${CURRENCY_SYMBOL}${basePrice}` : basePrice
    return (
        <>
            <div
                className="sm:pl-[2rem] xs:pl-[.5rem] sm:pr-[2rem] xs:pr-[.5rem] text-foreground"
                id="add-to-cart-content"
            >
                <div className="flex items-center pb-[2rem] pt-[1rem]">
                    <div className="flex text-[#4dcbb0] h-[2.625rem] w-[2.625rem] border border-solid border-[#4dcbb0] rounded-full items-center justify-center">
                        <SvgCheckmark className="text-[#4dcbb0] h-[1.4375rem]" />
                    </div>
                    <div className="pl-[1rem] leading-tight">
                        <Heading
                            tag="h2"
                            variant="h4"
                            className="font-body text-sm lg:text-base text-blue-900 leading-normal"
                        >
                            Added to your cart
                        </Heading>
                        <div className="text-[0.875rem]">
                            All products are {threeLetter} eligible
                        </div>
                    </div>
                </div>
                <div className="flex xs:flex-col sm:flex-row">
                    <div className="flex row flex-none xs:w-full sm:w-[70%] pr-[1rem]">
                        {/* Left Section Image, Title, Price, Quantity */}
                        <div className="pr-[1rem]">
                            {/* image container */}

                            <img
                                className="max-w-[12rem]  xs:w-[3rem] sm:w-[12rem] "
                                src={image}
                                alt={name}
                            />
                        </div>
                        <div className="flex flex-col">
                            <Heading
                                tag="h2"
                                variant="h4"
                                className="leading-7 font-grotesque font-medium text-sm lg:text-xl"
                            >
                                {name}
                            </Heading>
                            <div className="pt-[.75rem] pb-[.75rem] font-light">Price: </div>
                            <Heading
                                tag="h2"
                                variant="h6"
                                className="leading-7 font-grotesque font-medium pb-[.5rem] text-accent"
                            >
                                {displayPrice}
                            </Heading>
                            {/* {This Quantity is the total qty in the basket for this item} */}
                            <h3>Quantity: {quantity}</h3>
                        </div>
                    </div>
                    <div className="flex flex-col flex-none sm:w-[30%] gap-4 xs:w-full">
                        <div className="flex gap-1">
                            <span>Cart Subtotal ({totalItems}):</span>
                            <span>
                                {productSubTotal &&
                                    intl.formatNumber(productSubTotal, {
                                        style: 'currency',
                                        currency: currency
                                    })}
                            </span>
                        </div>
                        <div className="flex gap-2 xs:flex-row sm:flex-col">
                            <Button
                                ctaType="button"
                                onClick={closeModal}
                                variant="secondary"
                                className="xs:w-1/2 sm:w-full"
                            >
                                Keep Shopping
                            </Button>
                            <Button
                                ctaType="button"
                                hrefValue="/cart"
                                variant="primary"
                                className="xs:w-1/2 sm:w-full"
                            >
                                Checkout
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

AddToCartContent.propTypes = {
    closeModal: PropTypes.func,
    cartData: PropTypes.object,
    productData: PropTypes.object
}
